import React from 'react';
import { Typography } from '@mui/material';
import { Question } from '../../../types/questionnaire';
import { BaseQuestionView } from './BaseQuestionView';

interface InputViewProps {
  question: Question;
}

export const InputView: React.FC<InputViewProps> = ({ question }) => {
  const value = question.attributes?.value;

  // checkbox (булевий "так/ні") — на відміну від одинарного чекбоксу, тут є 3 чіткі стани:
  // не вибрано нічого (немає відповіді) / "Так" / "Ні".
  if (question.type === 'checkbox') {
    const hasAnswer = value === true || value === false || value === 'true' || value === 'false';
    const checked = value === true || value === 'true';
    return (
      <BaseQuestionView question={question}>
        <Typography variant="body1" color={hasAnswer ? 'text.primary' : 'text.disabled'}>
          {hasAnswer ? (checked ? 'Так' : 'Ні') : 'Немає відповіді'}
        </Typography>
      </BaseQuestionView>
    );
  }

  const hasValue = value !== undefined && value !== null && value !== '';

  return (
    <BaseQuestionView question={question}>
      <Typography variant="body1" color={hasValue ? 'text.primary' : 'text.disabled'} sx={{ whiteSpace: 'pre-wrap' }}>
        {hasValue ? String(value) : 'Немає відповіді'}
      </Typography>
    </BaseQuestionView>
  );
};
